import { CsvHeaderModel } from '../../../models/CsvHeader';

export const MASTER_SUB_CATEGORIES_CSV_HEADER: CsvHeaderModel[] = [
  {
    label: 'id',
    key: 'no_sub',
  },
  {
    label: 'masterSubCategoryNameEn',
    key: 'sub_category_name_en',
  },
  {
    label: 'masterSubCategoryNameLa',
    key: 'sub_category_name_la',
  },
  {
    label: 'masterCategoryName',
    key: 'masterCategoryName',
  },
  {
    label: 'description',
    key: 'description',
  },
  {
    label: 'code',
    key: 'code',
  },
];
